import React from 'react'
import styles from './catalogoCard.module.css';
import { FaStar } from "react-icons/fa";

const CatalogoCard = ({ title, genres, plot, year, poster, fullplot }) => {
  return (
    <div className={styles.catalogo_card}>
      
      {/* Imagem deve ficar diretamente dentro do card */}
      <img src={poster} alt={title} />

      {/* Texto sobreposto (hover) */}
      <div className={styles.textoCentro}>
        <h1>
          <FaStar color='#ffc107' />
          <FaStar color='#ffc107' />
          <FaStar color='#ffc107' />
          <FaStar color='#ffc107' />
          <FaStar color='#ffc107' />
        </h1>
        <h1>{title}</h1>
      </div>

      {/* Info inferior */}
      <div className={styles.catalogo_info}>
        <h4 className={styles.genero}>
          <span>Gênero: </span> {genres}
        </h4>
        <h4>
          <span>Ano: </span> {year}
        </h4>
      </div>

    </div>
  );
};

export default CatalogoCard;
